import styled from 'styled-components'
import NotificationBarIconWrapper from '../../NotificationBarIconWrapper'
import {chooseIconColor} from '../../utils'

export const CloseIconWrapper = styled(NotificationBarIconWrapper)`
  color: ${props => chooseIconColor(props.type, props.theme, 'closeColorFunc')};
  cursor: pointer;
  opacity: 0.8;
  align-self: center;

  &:hover {
    opacity: 1;
  }
`
